import { forwardRef, MutableRefObject, FunctionComponent, ReactNode } from 'react'
import cn from 'clsx'

import styles from './shadowbox.css'

type ShadowBoxProps = {
  className?: string
  fullOnMobile?: boolean
  innerRef?: MutableRefObject<HTMLDivElement | null>
  children: ReactNode
}

const ShadowBox: FunctionComponent<ShadowBoxProps> = ({ className, children, fullOnMobile, innerRef }: ShadowBoxProps): JSX.Element => (
  <div className={cn(styles.shadowBox, fullOnMobile && styles.fullOnMobile, className)} ref={innerRef}>
    {children}
  </div>
)

export default forwardRef((props: ShadowBoxProps, ref) => <ShadowBox {...props} innerRef={ref} />)
